import { GeneratedForm } from '@adornis/generated-form/generated-form.js';
import type { EditorFunc } from '@adornis/prosemirror-editor/types.js';
import { html } from 'lit';
import type { BHBuildifyFlexConfiguration } from './configuration.js';

export const flexEditor: EditorFunc<BHBuildifyFlexConfiguration> = ({ form }) => html`${GeneratedForm({ form })}`;
